export default "__VITE_ASSET__B4x7PCDB__"